/**
 * Guard for the online state.
 *
 * @stable
 */

import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class OnlineState {
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);

  canActivate(): boolean {
    if (window.ZEF && window.ZEF.status !== 'online') {
      this.router.navigate(['/offline']);

      return false;
    }

    return true;
  }
}
